import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=ca3e5f1a&scoped=true"
import script from "./OtpVerification.vue?vue&type=script&lang=js"
export * from "./OtpVerification.vue?vue&type=script&lang=js"
import style0 from "./OtpVerification.vue?vue&type=style&index=0&id=ca3e5f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3e5f1a",
  null
  
)

export default component.exports